/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum SysOrgRoleName {
    GUEST = 'Guest',
    MEMBER = 'Member',
    VIEW_SETUP = 'ViewSetup',
    SETUP_BASIC = 'SetupBasic',
    SETUP_ITEMS = 'SetupItems',
    USER_ADMIN = 'UserAdmin',
    _UNKNOWN = '_Unknown',
}
